import TechnologyDetailPage from "@/pages/technologies/components/TechnologyDetailPage";

export default function AiTechPage() {
  return <TechnologyDetailPage slug="ai-development" />;
}